/* @flow weak */
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator.jsx';
import React from 'react';
import OrganizationAccountActions from 'actions/OrganizationAccountActions';
import Modal from 'components/Modal.jsx';
import JoinMergeAccountsView from 'join/components/JoinMergeAccountsView.jsx';
import ToastActions from 'actions/ToastActions';
import EventTracking from 'lib/EventTracking';

const EVENT_SCREEN_NAME = 'JoinMergeAccountsModal';

class JoinMergeAccountsModal extends React.Component {
  static propTypes = {
    token: React.PropTypes.string.isRequired,
  };

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  static childContextTypes = {
    eventScreenName: React.PropTypes.string,
  };

  state = {
    account: null,
    submitting: false,
  };

  getChildContext() {
    return {
      eventScreenName: EVENT_SCREEN_NAME,
    };
  }

  componentDidMount() {
    OrganizationAccountActions.getOrLoadAccount(this.props.token)
      .then(account => this.setState({ account }));
  }

  onError = (error) => {
    this.setState({ submitting: false });
    ToastActions.showErrorToast(error.message);
    this.props.onRequestHide();
  };

  mergeAccount = () => {
    this.setState({ submitting: true });
    OrganizationAccountActions.mergeAccount(this.props.token)
      .then(() => {
        const { account } = this.state;
        this.setState({ submitting: false });
        const successMessage = `${account.user_email} added to your account`;
        ToastActions.showSuccessToast(successMessage);
        this.props.onRequestHide(account.organization_group_code);
        EventTracking.view('join_merge_account_success');
      }, this.onError);
  };

  rejectAccount = () => {
    this.setState({ submitting: true });
    OrganizationAccountActions.rejectAccount(this.props.token)
      .then(() => {
        this.setState({ submitting: false });
        this.props.onRequestHide();
      }, this.onError);
  };

  render() {
    const { account, submitting } = this.state;
    if (!account || submitting) {
      return (
        <Modal>
          <CenteredLoadingIndicator />
        </Modal>
      );
    }

    return (
      <JoinMergeAccountsView
        onRequestHide={this.props.onRequestHide}
        account={account}
        mergeAccount={this.mergeAccount}
        rejectAccount={this.rejectAccount}
      />
    );
  }
}

export default JoinMergeAccountsModal;



// WEBPACK FOOTER //
// ./src/join/components/JoinMergeAccountsModal.jsx